import React from "react";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router";
import TextField from "@mui/material/TextField";

import useAuth from "../../hooks/useAuth";
import useQueryParams from "../../hooks/useQueryParams";
import InventoryTransactionMultipleModal from "../../components/modals/InventoryTransactionMultipleModal/index";

const name = "availableQuantity";

export default function AvailableQuantityInput({
  type,
  display,
  asset,
  disabledForm,
  onRestockInventory,
  component: Component,
  sameLocation,
}) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const params = useQueryParams();
  const routeAssetId = params.get("assetId");
  const openInventoryPlacement =
    params.get("inventoryPlacement") === "true" &&
    (!routeAssetId || String(routeAssetId) === String(asset.id));
  const { values, setFieldValue, errors, submitCount, getFieldMeta, getFieldProps } = useFormikContext();
  const meta = getFieldMeta(name);
  const errorMessage = meta.error || errors[name];
  const error = (meta.touched || submitCount > 0) && errorMessage;
  const label = type === "item" ? "Inventory Placement" : user.company.settings.quantity_label;

  const toggleInventoryPlacement = () => {
    if (disabledForm) return;

    if (openInventoryPlacement) {
      params.delete("inventoryPlacement");
    } else {
      params.set("inventoryPlacement", "true");
      params.set("assetId", asset.id);
    }
    navigate({ search: params.toString() });
  };

  return (
    <>
      {Component ? (
        <Component asset={asset} onClick={toggleInventoryPlacement} />
      ) : (
        <TextField
          fullWidth
          value={asset[name]}
          size="small"
          label={label}
          error={!!error}
          helperText={error}
          onClick={toggleInventoryPlacement}
          disabled={disabledForm}
          onKeyDown={e => {
            if (e.key === "Enter") {
              toggleInventoryPlacement();
            }
          }}
        />
      )}
      {openInventoryPlacement && (
        <InventoryTransactionMultipleModal
          title="Inventory Placement"
          open={true}
          onClose={toggleInventoryPlacement}
          onSuccess={(data, values) => {
            setFieldValue("quantityReceived", data.asset.quantityReceived);
            toggleInventoryPlacement();
            if (onRestockInventory) {
              onRestockInventory(data, values);
            }
          }}
          asset={asset}
          code={asset.assetId}
          quantityOrdered={display.quantity_ordered}
          quantityReceived={display.quantity_received}
          sameLocation={sameLocation}
          shipmentItemQuantity={values.shipmentItemQuantity}
          onShipmentItemQuantityUpdate={quantity => setFieldValue("shipmentItemQuantity", quantity)}
        />
      )}
    </>
  );
}
